<template>
    <div class="publishers-autocomplete-container">

        <div class="publishers-autocomplete-input" @mouseover="onMouseOver" @mouseleave="onInputMouseLeave">
            <input ref="InputElem"
                   type="text"
                   placeholder="Please select an account or search for one"
                   v-model="searchTerm"
                   @input="onKeyup" />
            <div v-show="getHasSearchTerm" class="clearBox" @click="clearSearchTerm()">
                <img width="12" height="12" src="/Style/close_icon_2.png" />
            </div>
            <div v-show="!getHasSearchTerm" class="arrow-down">
                <img width="8" height="8" src="/Style/arrow_down_icon.png" />
            </div>
        </div>

        <ul ref="publishersListElem" tabindex="0" class="autocomplete-results" @mouseleave="onMouseLeave" v-show="getShowAutocomplete">
            <li tabindex="-1"
                class="autocomplete-result"
                v-for="(pub, index) in getPublishers"
                @click.prevent="selectItem(pub)">
                {{ pub.pb_company }} &nbsp; ({{ pub.pb_email }})
            </li>
        </ul>

    </div>
</template>

<script>

    import { mapGetters, mapMutations, mapActions } from 'vuex';
    import Vue from 'vue';

    export default {
        props: {
        },
        data() {
            return {
                sessionStorageKey: "ss_pb_admin",
                cachedPublishersList: [],
                publishersList: [],
                searchTerm: '',
                minTermLength: 3,
                selectedItem: null,
                show: false,
                timerId: undefined
            };
        },
        methods: {
            onMouseOver() {
                this.show = true;
            },
            clearSearchTerm() {
                this.searchTerm = "";
                this.publishersList = this.cachedPublishersList || [];

                if (this.$refs && this.$refs.InputElem) {

                    console.log(this.$refs);
                    console.log(this.$refs.InputElem);

                    this.$refs.InputElem.focus();

                }
            },
            changePublisher(selectedPublisher) {

                var that = this;
                var pb_id = selectedPublisher.pb_id;
                var pb_number = selectedPublisher.pb_number;
                var pb_company = selectedPublisher.pb_company;
                var pb_email = selectedPublisher.pb_email;

                // this.loader.show();
                // let pb_number = data.publisherNumber;

                var uri = new URL(location.href);
                var host_parts = uri.host.split('.');
                if (host_parts.length > 3)
                    host_parts = Object.values({ ...host_parts, [0]: pb_number });
                else
                    host_parts = [pb_number, ...host_parts];

                let rootDomain = host_parts.slice(1).join('.');

                var host = host_parts.join('.');
                uri.host = host;
                //let url = uri.toString();
                let url_dashboard = location.protocol + "//" + host + "/Dashboard.aspx"
                this.clearSearchTerm();

                let ddd = {
                    url: url_dashboard,
                    name: pb_company,
                    email: pb_email,
                    pb_number: pb_number
                }

                let _enc = unescape(encodeURIComponent(JSON.stringify(ddd)));
                let enc = window.btoa(_enc);

                try {
                    var win = window.open('//' + rootDomain + '/AccountRedirect.html?d=' + enc, '_blank');
                }
                catch (e) {
                    window.location.href = url_dashboard;
                }




            },
            getPublishersAutocomplete(term) {

                let url = '/publisher/service.asmx/getPublisherListByQuery';

                var scope = this;
                Vue.$http.post(url, { query: term || '' }).then((response) => {

                    if (response.data && response.data.d) {

                        const data = JSON.parse(response.data.d);
                        this.show = true;
                        scope.cachedPublishersList = scope.publishersList;
                        scope.publishersList = data;

                    }

                }).catch((error) => {

                    //this.searchTerm = '';

                });
            },
            selectItem: function (pub) {

                // this.selectedItem = pub;
                this.show = false;
                this.searchTerm = '';

                this.changePublisher(pub);
            },
            onInputMouseLeave() {
                if (this.searchTerm === "" && this.selectedItem != undefined) {
                    this.searchTerm = this.selectedItem.pb_company + " (" + this.selectedItem.pb_email + ")";
                }
            },
            onMouseLeave() {

                let scope = this;

                setTimeout(() => {

                    scope.show = false;

                    if (scope.searchTerm === "" && scope.selectedItem != undefined) {
                        scope.searchTerm = scope.selectedItem.pb_company + " (" + scope.selectedItem.pb_email + ")";
                    }

                }, 500);
            },
            onKeyup() {

                if (this.timerId) {
                    clearTimeout(this.timerId);
                }

                this.timerId = setTimeout(() => {

                    //console.log("inside: " + this.timerId);

                    let term = this.searchTerm;
                    if (term.length >= this.minTermLength) {
                        this.getPublishersAutocomplete(term);
                    }

                }, 800);

            }
        },

        mounted() {

        },
        computed: {

            ...mapGetters([
                'isAdmin',
                'getPublisherEmail',
                'getPublisherCompanyName'
            ]),

            getHasSearchTerm() {
                let term = this.searchTerm;
                if (term.length > 0) {
                    return true;
                } else {
                    return false;
                }
            },
            getShowAutocomplete() {

                if (this.$refs && this.$refs.publishersListElem && this.$refs.publishersListElem.children.length > 0) {

                    let parent = this.$refs.publishersListElem;
                    //parent.focus();

                    let firstChild = parent.firstChild;
                    firstChild.focus();
                }

                return this.show && this.getPublishers.length > 0;
            },
            getPublishers() {
                return this.publishersList;
            }
        },
        created() {

            let publisherEmail = this.getPublisherEmail;
            let publisherCompany = this.getPublisherCompanyName;

            if (publisherEmail && publisherEmail != "") {

                this.selectedItem = {
                    pb_email: publisherEmail,
                    pb_company: publisherCompany
                };

                this.searchTerm = publisherCompany + " (" + publisherEmail + ")";

            } else {
                this.getPublishersAutocomplete("");
            }
        }
    }
</script>

<style>

    ul {
        margin: 0;
        padding: 0;
    }

    .publishers-autocomplete-input .arrow-down {
        position: absolute;
        top: 13px;
        right: 0;
    }

    .publishers-autocomplete-input .clearBox {
        position: absolute;
        top: 11px;
        right: 0;
        cursor: pointer;
    }

    .publishers-autocomplete-container {
        position: absolute;
        width: 400px;
        padding: 4px 0px;
        box-shadow: 2px #888888;
        right: 0;
        z-index: 1001;
    }

    .relative .publishers-autocomplete-container {
        position: relative;
    }

    .publishers-autocomplete-container p {
        padding: 4px;
        border: #777 1px solid;
        background: #fff;
        border-radius: 5px;
        color: #000;
        box-shadow: 5px 5px #A9A9A9;
        font-size: 12px;
        line-height: 12px
    }

    .autocomplete p i {
        float: right;
    }

    .publishers-autocomplete-container input {
        position: relative;
        font-size: 12px !important;
        line-height: 12px !important;
        width: 400px;
        border: #777 1px solid;
        padding: 4px;
    }

    .publishers-autocomplete-container .autocomplete-results li input {
        position: relative;
        font-size: 12px !important;
        line-height: 12px !important;
        border-radius: 15px;
    }

    .autocomplete-results {
        border: 1px solid #555;
        max-height: 400px;
        width: 400px;
        overflow: auto;
        position: relative;
        background: #fff;
        z-index: 99999;
        padding: 4px;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 4px;
        cursor: pointer;
        border-top: 1px solid #F1F1F1;
        color: #000;
        font-size: 12px;
        line-height: 12px;
    }

        .autocomplete-result:hover {
            background-color: #4AAE9B;
            color: white;
        }
</style>



// WEBPACK FOOTER //
// src/components/Common/appPublisherCombo.vue